<template>
  <v-btn
    :flat="!copied"
    :color="copied ? 'green' : 'grey'"
    @click="copy(copyText)"
    :disabled="playlistModalLoading">
    <span v-if="!copied">Copy</span>
    <span v-else class="white--text">Copied</span>
  </v-btn>
</template>

<script>
/* global _ */
/* global moment */
import { mapState } from 'vuex';
import _ from 'lodash';

export default {
  name: 'ClipboardCopy',
  components: {  },
  props: [ 
    'copyText', 
  ], 
  data() {
    return { 
      copied: false,
    } 
  },
  methods: {
    copy() {
      navigator.clipboard.writeText(this.copyText);
      this.copied = true;
      setTimeout(() => { this.copied = false; }, 3000);
    }
  },
  computed: {
    ...mapState('instructors', [
      'playlistModalLoading',
    ]),
  }
};
</script>
